import React from 'react';
import Form from '@atlaskit/form';
import './search-form.scss';

export const searchFieldKey = 'query';
export const searchContextKey = 'context';

export interface SearchData {
  [searchFieldKey]: string;
  [searchContextKey]: string;
}
type ChildrenProp = (args: { onReset: () => void }) => JSX.Element;

interface SearchFormProps {
  onSubmit: (data: any) => void;
  children: ChildrenProp;
  isRefetchOnClearEnabled?: boolean;
}

interface SearchSubmitEvent {
  [key: string]: any;
}

/**
 *
 * @param onSubmit
 * @param children
 * @param isRefetchOnClearEnabled Re-submit the form on resetting the value by onReset method
 * @constructor
 */
export const SearchForm = ({ onSubmit, children, isRefetchOnClearEnabled }: SearchFormProps) => {
  const handleReset = (getState: () => { values: SearchData }) => {
    if (isRefetchOnClearEnabled) {
      const resetData: SearchSubmitEvent = {
        ...getSubmittableData(getState().values),
        [searchFieldKey]: '',
      };
      onSubmit(resetData);
    }
  };

  const getSubmittableData = (data: SearchSubmitEvent) => {
    const finalData: SearchSubmitEvent = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (key === searchContextKey) {
          finalData[key] = data[key]?.value;
          continue;
        }
        finalData[key] = data[key].trim();
      }
    }
    return finalData;
  };

  const handleSubmit = (data: SearchSubmitEvent) => {
    onSubmit(getSubmittableData(data));
  };

  return (
    <div className={'search-form-container'}>
      <div className="search-form">
        <Form<SearchData> onSubmit={handleSubmit}>
          {({ formProps, getState }) => (
            <form data-testid="partner-search-form" {...formProps}>
              <div className="main-container">{children({ onReset: handleReset.bind(null, getState) })}</div>
            </form>
          )}
        </Form>
      </div>
    </div>
  );
};
